import request from '../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../types/enums/request-enums';

const GetAIStudioAnalytics = (): Promise<any> =>
    request({
        url: ApiURL.Query.StudioQueryURLs.AIStudioAnalyticsQueryURL.GetAnalytics,
        method: RequestType.GET,
    });

interface FilteredStatsParams {
    username?: string;
    startDate?: string;
    endDate?: string;
    productCode?: string;
}

const GetFilteredStats = (params?: FilteredStatsParams): Promise<any> => {
    const queryParams = new URLSearchParams();
    if (params?.username) queryParams.append('username', params.username);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    if (params?.productCode) queryParams.append('productCode', params.productCode);

    const queryString = queryParams.toString();
    const url = ApiURL.Query.StudioQueryURLs.AIStudioAnalyticsQueryURL.GetFilteredStats + (queryString ? `?${queryString}` : '');

    return request({
        url,
        method: RequestType.GET,
    });
};

const GetUserTransactions = (params: {
    username: string;
    pageNumber?: number;
    pageSize?: number;
    startDate?: string;
    endDate?: string;
    productCode?: string;
}): Promise<any> => {
    const { username, pageNumber = 1, pageSize = 50, startDate, endDate, productCode } = params;
    const queryParams = new URLSearchParams();
    queryParams.append('pageNumber', String(pageNumber));
    queryParams.append('pageSize', String(pageSize));
    if (startDate) queryParams.append('startDate', startDate);
    if (endDate) queryParams.append('endDate', endDate);
    if (productCode) queryParams.append('productCode', productCode);

    const queryString = queryParams.toString();
    const baseUrl = ApiURL.Query.StudioQueryURLs.AIStudioAnalyticsQueryURL.GetUserTransactions(username?.toLowerCase());
    const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    return request({
        url,
        method: RequestType.GET,
    });
};

const GetTransactionDetail = (id: number): Promise<any> =>
    request({
        url: ApiURL.Query.StudioQueryURLs.AIStudioAnalyticsQueryURL.GetTransactionDetail(id),
        method: RequestType.GET,
    });

interface ProductGenerationReportParams {
    username?: string;
    startDate?: string;
    endDate?: string;
    pageNumber?: number;
    pageSize?: number;
    productCode?: string;
}

const GetProductGenerationReport = (params?: ProductGenerationReportParams): Promise<any> => {
    const queryParams = new URLSearchParams();
    if (params?.username) {
        queryParams.append('username', params.username);
    }
    if (params?.startDate) {
        queryParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
        queryParams.append('endDate', params.endDate);
    }
    if (params?.productCode) {
        queryParams.append('productCode', params.productCode);
    }
    queryParams.append('pageNumber', String(params?.pageNumber ?? 1));
    queryParams.append('pageSize', String(params?.pageSize ?? 50));

    const qs = queryParams.toString();
    const url =
        ApiURL.Query.StudioQueryURLs.AIStudioAnalyticsQueryURL.GetProductGenerationReport +
        (qs ? `?${qs}` : '');

    return request({
        url,
        method: RequestType.GET,
    });
};

const AIStudioAnalyticsQuery = {
    GetAIStudioAnalytics,
    GetFilteredStats,
    GetUserTransactions,
    GetTransactionDetail,
    GetProductGenerationReport,
};

export default AIStudioAnalyticsQuery;

